import { Navigate, useLocation } from 'react-router-dom';
import { connectAiReasonFromSearch } from '../utils/connectAiPopup';

/**
 * Redirecionamento da raiz (/).
 *
 * Quando o Supabase envia recuperação de senha com redirect_to = origem do site
 * (ex.: https://app.giobrain.com), o usuário volta com ?code= (PKCE) ou
 * #access_token=…&type=recovery no /. O <Navigate to="/acess" /> antigo descartava
 * query e hash antes do cliente trocar o código por sessão — resultado: login sem sessão.
 */
function parseAuthParams(search, hash) {
  const searchParams = new URLSearchParams(search);
  const hashClean = hash.startsWith('#') ? hash.slice(1) : hash;
  const hashParams = new URLSearchParams(hashClean);
  const get = (key) => searchParams.get(key) ?? hashParams.get(key);

  return {
    type: get('type'),
    hasCode: Boolean(get('code')),
    tokenHash: get('token_hash') || get('token'),
    hasError: Boolean(get('error_description')),
    suffix: `${search}${hash}`,
  };
}

export default function RootRedirect() {
  const { search, hash } = useLocation();
  const { type, hasCode, tokenHash, hasError, suffix } = parseAuthParams(search, hash);

  if (hasError) {
    return <Navigate to={`/acess${suffix}`} replace />;
  }

  if (type === 'recovery' || (tokenHash && type === 'recovery')) {
    return <Navigate to={`/reset-password${suffix}`} replace />;
  }

  if (hash && hash.includes('type=recovery')) {
    return <Navigate to={`/reset-password${suffix}`} replace />;
  }

  // PKCE na raiz (redirect_to sem path) — típico de e-mail de recuperação mal configurado
  if (hasCode) {
    return <Navigate to={`/reset-password${suffix}`} replace />;
  }

  const connectAi = connectAiReasonFromSearch(search);
  return <Navigate to={connectAi ? `/acess?connect_ai=${encodeURIComponent(connectAi)}` : '/acess'} replace />;
}
